import http from './index'

// 公开读取的 collection (前台只读 status=online 的记录)
const PUBLIC_BASE = '/api/collections'

// 通用列表获取
function listRecords(collection, params = {}) {
  return http.get(`${PUBLIC_BASE}/${collection}/records`, {
    params: { perPage: 100, sort: 'sort', ...params }
  }).then(r => r.data)
}

function getFirstRecord(collection, params = {}) {
  return http.get(`${PUBLIC_BASE}/${collection}/records`, {
    params: { perPage: 1, ...params }
  }).then(r => r.data.items[0] || null)
}

// 构造 PocketBase 文件 URL
// 用法: fileUrl(record, record.img)
export function fileUrl(record, filename, queryParams = {}) {
  if (!record || !filename) return ''
  const collectionId = record.collectionId || record['@collectionId']
  const recordId = record.id
  const qs = Object.keys(queryParams).length
    ? '?' + Object.entries(queryParams).map(([k,v]) => `${k}=${encodeURIComponent(v)}`).join('&')
    : ''
  return `/api/files/${collectionId}/${recordId}/${filename}${qs}`
}

// 业务接口

const api = {
  // 首页轮播图(按 sort 升序)
  banners() {
    return listRecords('banner', { sort: 'sort,created' })
  },

  // 数字统计
  stats() {
    return listRecords('stat', { sort: 'sort,created' })
  },

  // 联系留言 - 公开提交(不需要 auth)
  submitMessage(data) {
    return http.post(`${PUBLIC_BASE}/message/records`, data).then(r => r.data)
  },

  // 新闻动态
  news(type, page = 1, perPage = 20) {
    const filter = type ? `type = "${type}"` : ''
    return listRecords('news', { filter, sort: '-publish_time', page, perPage })
  },

  // 单条新闻
  newsOne(id) {
    return http.get(`${PUBLIC_BASE}/news/records/${id}`).then(r => r.data)
  },

  // 品牌(派美制药/派美保健/灵舟器械)
  brands() {
    return listRecords('brand', { sort: 'sort,created' })
  },

  brandByKey(key) {
    return getFirstRecord('brand', { filter: `brand_key = "${key}"` })
  },

  // 研发管线
  rdLines() {
    return listRecords('rd_line', { sort: 'sort,created' })
  },

  rdLineByKey(key) {
    return getFirstRecord('rd_line', { filter: `rd_key = "${key}"` })
  },

  // 研发管线下的技术平台(含要点)
  rdPlatforms(rdLineId) {
    return http.get(`${PUBLIC_BASE}/rd_platform/records`, {
      params: {
        filter: `rd_line = "${rdLineId}"`,
        sort: 'sort,created',
        expand: 'rd_platform_point(platform)'
      }
    }).then(r => r.data)
  },

  // 创始股东
  founders() {
    return listRecords('founder', { sort: 'sort,created' })
  },

  // 营销体系
  marketing() {
    return listRecords('marketing', { sort: 'sort,created' })
  },

  // 公司团队
  team() {
    return listRecords('team', { sort: 'sort,created' })
  },

  // 公司介绍分节(按 section_key 查)
  companySection(sectionKey) {
    return getFirstRecord('company_section', { filter: `section_key = "${sectionKey}"` })
  },

  // 全局配置 - 全量返回(KV 数量少)
  async configAll() {
    const r = await listRecords('config', { sort: 'config_key', perPage: 200 })
    const kv = {}
    for (const item of r.items) {
      if (item.config_key.startsWith('__editor_img_')) continue
      kv[item.config_key] = {
        value: item.config_value,
        image: item.config_image,
        record: item
      }
    }
    return kv
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/api.js